module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/vi_2-a45cde5f42bca905289258c967cd8cc0.jpg";